import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import * as moment from 'moment-timezone';
import { Observable } from 'rxjs';

import { CoachSettingsGeneralDiplomaController } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-diploma/coach-settings-general-diploma.controller';
import { CoachSettingsGeneralFormController } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-form.controller';

@Component({
	selector: 'spr-coach-settings-general-diploma',
	templateUrl: './coach-settings-general-diploma.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		CoachSettingsGeneralDiplomaController,
		CoachSettingsGeneralFormController,
	],
	host: {
		class: 'flex flex-col h-full items-center space-y-3',
	},
})
export class CoachSettingsGeneralDiplomaComponent {
	public calendarLocale$: Observable<any>;
	public referenceDateRange: string;
	public diplomasArray: FormArray;
	public newDiploma: FormGroup;
	public form: FormGroup;

	@Input()
	public set diplomaForm(form: FormGroup) {
		this.diplomasArray = form.get('diplomas') as FormArray;
		this.newDiploma = form.get('newDiploma') as FormGroup;
		this.form = form;
	}

	constructor(public controller: CoachSettingsGeneralDiplomaController) {
		this.calendarLocale$ = controller.calendarLocale$;
		const referenceMaxYear = moment().year();
		const referenceMinYear = moment().subtract(70, 'year').year();
		this.referenceDateRange = `${referenceMinYear}:${referenceMaxYear}`;
	}

	public onRemoveDiplomaClick(index: number) {
		this.controller.removeDiploma(index, this.form);
	}

	public onAddDiplomaClick() {
		this.controller.addDiploma(this.form);
	}
}
